import { Company } from '../../enums/financial.enum';

export type MovementType = 'factura' | 'gasto';

export interface SpentItem {
  id: number;
  cantidad: number;
  detalle_gasto: string;
  precio_unitario: number;
  iva: number;
  subtotal: number;
  ivaAmount: number;
  total: number;
}

export interface BankInfo {
  identificacion: string;
  beneficiario: string;
  numero_cuenta: string;
  id_banco: number | null;
}

export interface DocumentFile {
  id: number;
  file: File;
  name: string;
  type: string;
  size: number;
  preview: string | null;
}

export interface CreateMovementFormData {
  empresa: number | null;
  id_categoria: number | null;
  id_codigo: number | null;
  detalle: string;
  spents: SpentItem[];
  bankInfo: BankInfo;
  documents: DocumentFile[];
}

export interface CreateMovementPayload {
  detalle: string;
  id_codigo: number;
  id_pais: number;
  empresa: number;
  id_usuario: number;
  numero_factura?: number | null;
  numero_gasto?: number | null;
  identificacion: string | null;
  beneficiario: string | null;
  numero_cuenta: string | null;
  id_banco: number | null;
  spents: {
    cantidad: number;
    precio_unitario: number;
    iva: number;
    total: number;
    detalle_gasto: string;
  }[];
}

export interface CreateMovementResult {
  financial: {
    id_financiero: number;
    numero_factura?: number;
    numero_gasto?: number;
  };
  documents: unknown[];
  spents: unknown[];
  summary: {
    subtotalBase: number;
    totalIva: number;
    totalGlobal: number;
  };
  tipoMovimiento: string;
  numeroMovimiento: number;
}

export interface SelectOption {
  value: number;
  label: string;
  codigo?: string;
}

export interface BankOption {
  idabpa_banco: number;
  banco: string;
}

export interface AccountingAccountOption {
  id_codigos: number;
  codigo_cuenta: string;
  nombre_cuenta: string;
}

export interface WizardStep {
  index: number;
  title: string;
  icon: string;
  isValid: boolean;
  isActive: boolean;
  isCompleted: boolean;
}

export interface AccountingCompanyOption {
  id: number;
  name: string;
  code: string;
}

export interface AccountingCategoryOption {
  id: number;
  code: string;
  name: string;
}

export interface AccountingAccountDetailOption {
  id: number;
  code: string;
  name: string;
}

export interface ParentMovementData {
  id: number;
  numeroMovimiento: string;
  empresa: Company | string;
  empresaId: number;
  categoriaId: number | null;
  cuentaId: number | null;
  detalle: string;
  beneficiario: string;
  identificacion: string;
  numeroCuenta: string;
  bancoId: number | null;
}

export interface ForkCountResult {
  count: number;
  maxAllowed: number;
  canFork: boolean;
}
